module.exports = __webpack_public_path__ + "static/media/register.49b54380.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register.jpeg
// module id = 747
// module chunks = 0